import 'react';
import styled from 'styled-components';
import { palette } from '@cbhq/cds-web/tokens';
import { jsx } from 'react/jsx-runtime';
function PrivacyLink({
  children,
  color = 'light'
}) {
  return /*#__PURE__*/jsx(Link, {
    color: color,
    href: "https://www.coinbase.com/legal/cookie#:~:text=Targeting%20purposes,to%20you%20or%20your%20interests.",
    target: "_blank",
    rel: "noopener",
    children: children
  });
}
const Link = styled.a.withConfig({
  shouldForwardProp: p => !['color'].includes(p)
})`
  text-decoration: underline;
  color: ${({
  theme,
  color
}) => color === 'foregroundMuted' ? palette.foregroundMuted : color === 'primary' ? theme.colors.primary : theme.colors.onBackgroundMuted};
  &:visited {
    color: ${({
  theme,
  color
}) => color === 'foregroundMuted' ? palette.foregroundMuted : color === 'primary' ? theme.colors.primary : theme.colors.onBackgroundMuted};
  }
`;
export { PrivacyLink as default };
//# sourceMappingURL=PrivacyLink.js.map
